import React, {FC} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import {ShortcutText} from '@/common/components/ShortcutText';
import styles from './WeatherVerbal.css';

interface WeatherVerbalProps {
	verbal: {
		generic?: string;
		folk?: string;
	};
}

export const WeatherVerbal: FC<WeatherVerbalProps> = props => {
	const {verbal} = props;

	const t = useLocalizer();

	return (
		<>
			{verbal.generic && <p className={styles.row}>{verbal.generic}</p>}
			{verbal.folk && (
				<p className={styles.row}>
					<span className={styles.title}>{t('verbalFolk')}: </span>
					<ShortcutText length={108}>{verbal.folk}</ShortcutText>
				</p>
			)}
		</>
	);
};

WeatherVerbal.displayName = 'WeatherVerbal';
